/* eslint-disable react/no-array-index-key */

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// react-awesome-reveal for animations
import { Fade } from "react-awesome-reveal";

// Presentation page components
import ErrorBoundary from "components/ErrorBoundary";

// Data
import textData from "data/textData";

import InstagramPost from "../components/InstagramPost";
import PostErrorFallback from "../components/PostErrorFallback";

function InstagramFeed() {
  // Array de objetos con la información de cada publicación
  const instagramPosts = [
    {
      url: "https://www.instagram.com/p/CvBK0GxOShg/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==",
    },
    {
      url: "https://www.instagram.com/p/C3VwPfPOXmQ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    },
    {
      url: "https://www.instagram.com/reel/C43uV6iul9w/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    },
  ];

  return (
    <Grid container spacing={3} justifyContent="center" sx={{ mt: 4 }}>
      {instagramPosts.map((post, index) => (
        <Grid item xs={12} sm={6} lg={4} key={`${post.url}-${index}`}>
          <Fade direction="up" delay={index * 150} triggerOnce>
            <MKBox
              component="a"
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              display="block"
              sx={{
                position: "relative",
                borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
                overflow: "hidden",
                boxShadow: ({ boxShadows: { xl } }) => xl,
                transform: "scale(1)",
                transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.03)",
                  boxShadow: ({ boxShadows: { xxl } }) => xxl,
                  "& .overlay": {
                    opacity: 1,
                  },
                },
              }}
            >
              <ErrorBoundary fallback={<PostErrorFallback />}>
                <InstagramPost url={post.url} />
              </ErrorBoundary>
              <MKBox
                className="overlay"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: ({ functions: { rgba, linearGradient }, palette: { dark } }) =>
                    linearGradient(rgba(dark.main, 0.5), rgba(dark.main, 0.8)),
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  opacity: 0,
                  transition: "opacity 0.3s ease-in-out",
                }}
              >
                <Icon fontSize="large">instagram</Icon>
                <MKTypography color="white" variant="h5" fontWeight="bold" mt={1}>
                  {textData.presentationPage.instagram.viewOnInstagram}
                </MKTypography>
              </MKBox>
            </MKBox>
          </Fade>
        </Grid>
      ))}
    </Grid>
  );
}

export default InstagramFeed;
